import { render, staticRenderFns } from "./CharactersBackgrounds.vue?vue&type=template&id=3e22d8ae&lang=pug&"
import script from "./CharactersBackgrounds.vue?vue&type=script&lang=ts&"
export * from "./CharactersBackgrounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports